import ManageLabFeatures from "@pathwright/features/src/modules/account/manage/ManageLabFeatures"
import withLabFeatureVisibility from "@pathwright/features/src/modules/account/manage/withLabFeatureVisibility"
import ManageCoverPagesFeaturePermissions from "@pathwright/features/src/modules/feature/manage/ManageCoverPagesFeaturePermissions"
import ManageHomeScreenFeaturePermissions, {
  ConfirmLaunch,
  ConfirmPreview
} from "@pathwright/features/src/modules/feature/manage/ManageHomeScreenFeaturePermissions"

export default {
  lab: {
    component: withLabFeatureVisibility(ManageLabFeatures),
    childCards: {
      home: {
        component: withLabFeatureVisibility(
          ManageHomeScreenFeaturePermissions,
          "home"
        ),
        childCards: {
          "confirm-preview": {
            component: withLabFeatureVisibility(ConfirmPreview, "home")
          },
          "confirm-launch": {
            component: withLabFeatureVisibility(ConfirmLaunch, "home")
          }
        }
      },
      "cover-pages": {
        component: withLabFeatureVisibility(
          ManageCoverPagesFeaturePermissions,
          "coverPages"
        )
      }
    }
  }
}
